var cilDinner = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M464,344.063c0-109.308-84.755-199.193-192-207.39V80H240v56.673c-107.245,8.2-192,98.082-192,207.39V377.17H464Zm-32,1.107H80v-1.107c0-97.046,78.953-176,176-176s176,78.953,176,176Z' class='ci-primary'/><rect width='480' height='32' x='16' y='416' fill='var(--ci-primary-color, currentColor)' class='ci-primary'/>"];

export { cilDinner };

